module.exports = __webpack_public_path__ + "img/investicii.5c0e7d6e.png";